export default __webpack_public_path__ + "static/media/IMG_0407-2.327b0303.jpg";